import React, { useState, useEffect } from "react";
import SubCategoryItem from "../SubCategoryItem/SubCategoryItem";
import noFilter from "../../assets/images/noFilter.png";
import axios from "axios";

const SubCategory = (props) => {
  const [subCategory, setSubCategory] = useState([]);
  const [thirdCategoryData, setThirdCategoryData] = useState([]);
  const [categoryNum, setCategoryNum] = useState(0);
  useEffect(() => {
    axios
      .get(`Product/GetProductCategory/LubricatingOil`)
      .then((result) => {
        setSubCategory(result.data.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, []);
  useEffect(() => {
    setSubCategory(props.subCategory);
    setCategoryNum(props.categoryNum);
    let categories = document.querySelectorAll(".subs");
    categories.forEach((i) => i.classList.remove("active"));
    let filtered = [...categories].filter((i) => i.innerText === "همه");
    if (filtered.length > 0) {
      filtered[0].classList.add("active");
    }
  }, [props.subCategory, props.categoryNum]);
  const showThirdCategoryHandler = (data) => {
    if (data && data.length > 0) {
      setThirdCategoryData(data);
      props.setShowThirdCategory(true);
    } else {
      setThirdCategoryData([]);
      props.setShowThirdCategory(false);
    }
  };
  return (
    <React.Fragment>
      <div className="subCategory">
        {subCategory.length > 1 && (
          <div className={`subCategoryBox`} onClick={() => showThirdCategoryHandler()}>
            <SubCategoryItem showAll={true} image={noFilter} id={null} categoryTitle="همه" categoryNum={categoryNum} />
          </div>
        )}
        {subCategory.map((item, index) => {
          return (
            <div key={index} className={`subCategoryBox item${index + 1}`}>
              <SubCategoryItem
                image={item.image}
                id={item.id}
                categoryTitle={item.categoryName}
                subCategory={item.categories}
                showThirdCategory={showThirdCategoryHandler}
              />
            </div>
          );
        })}
      </div>
      {props.showThirdCategory && (
        <div className="subCategory sec">
          {thirdCategoryData.map((item, index) => {
            return (
              <div key={index} className={`subCategoryBox item${index + 1}`}>
                <SubCategoryItem image={item.image} id={item.id} categoryTitle={item.categoryName} isThirdCat={true} />
              </div>
            );
          })}
        </div>
      )}
    </React.Fragment>
  );
};

export default React.memo(SubCategory);
